import DialogModal from './src/index.vue';

export default DialogModal;
